import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NestApiProvider } from '../../nest-api';

@Injectable()
export class SfEmployeePayrollDataProvider {

  private _service: string = 'payroll';
  private _model: string = 'SFEmployeePayrollData';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public updatemppaydatabycomp(value: any = {}, empId: any = {}, typeValue: any = {}, formulaStatus: any = {}): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'updatemppaydatabycomp';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof value !== 'undefined' && value !== null) _urlParams.value = value;
    if (typeof empId !== 'undefined' && empId !== null) _urlParams.empId = empId;
    if (typeof typeValue !== 'undefined' && typeValue !== null) _urlParams.typeValue = typeValue;
    if (typeof formulaStatus !== 'undefined' && formulaStatus !== null) _urlParams.formulaStatus = formulaStatus;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _func, _params, _body);
  }

  public getCountEmployee(): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getCountEmployee';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/sf-employee-payroll-data/sf-employee-payroll-data.ts